import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-itams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationDetailsItamsConstants } from "./create-application-details-itams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { InformalTradeService } from "../../../../shared/services/modules/informal-trade.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../shared/models/alert";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
let CreateApplicationDetailsItamsComponent = class CreateApplicationDetailsItamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    informalTradeService;
    changeDetectorRef;
    searchApplicationsService;
    // Labels
    descriptionLabel = CreateApplicationDetailsItamsConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LABEL;
    tradingGoodsLabel = CreateApplicationDetailsItamsConstants.TRADING_GOODS_LABEL;
    tradingGoodsDescriptionLabel = CreateApplicationDetailsItamsConstants.TRADING_GOODS_DESCRIPTION_LABEL;
    previousApplicationReferenceNumberLabel = CreateApplicationDetailsItamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_LABEL;
    verifyReferenceNumberLabel = CreateApplicationDetailsItamsConstants.VERIFY_REFERENCE_NUMBER_LABEL;
    referenceNumberVerifiedLabel = CreateApplicationDetailsItamsConstants.REFERENCE_VERIFIED_LABEL;
    unverifiedReferenceNumberLabel = CreateApplicationDetailsItamsConstants.REFERENCE_NOT_VERIFIED_LABEL;
    // Form controls
    detailsFormGroupName = CreateApplicationDetailsItamsConstants.DETAILS_FORM_GROUP_NAME;
    tradeGoodsFormArray = CreateApplicationDetailsItamsConstants.TRADING_GOODS_FORM_ARRAY_NAME;
    tradeGoodsFormControlName = CreateApplicationDetailsItamsConstants.TRADING_GOODS_CONTROL_NAME;
    descriptionFormControlName = CreateApplicationDetailsItamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    tradingGoodsFormControlName = CreateApplicationDetailsItamsConstants.TRADING_GOODS_CONTROL_NAME;
    previousApplicationValidatedFormControlName = CreateApplicationDetailsItamsConstants.PREVIOUS_APPLICATION_VALIDATED_CONTROL_NAME;
    tradingGoodsDescriptionFormControlName = CreateApplicationDetailsItamsConstants.TRADING_GOODS_DESCRIPTION_FORM_CONTROL_NAME;
    previousApplicationReferenceNumberFormControlName = CreateApplicationDetailsItamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_CONTROL_NAME;
    tradersFormGroupName = CreateApplicationDetailsItamsConstants.TRADERS_FORM_GROUP_NAME;
    baysFormGroupName = CreateApplicationDetailsItamsConstants.BAYS_FORM_GROUP_NAME;
    baysFormControl = CreateApplicationDetailsItamsConstants.BAYS_FORM_CONTROL_NAME;
    tradersFormControlName = CreateApplicationDetailsItamsConstants.TRADERS_FORM_CONTROL_NAME;
    centroidFromControlName = CreateApplicationDetailsItamsConstants.CENTROID_FORM_CONTROL_NAME;
    deleteTradingGoodsLabel = CreateApplicationDetailsItamsConstants.REMOVE_TRADING_GOODS_LABEL;
    addTradingGoodsLabel = CreateApplicationDetailsItamsConstants.ADD_TRADING_GOODS_LABEL;
    // constants
    validationMessages = CreateApplicationDetailsItamsConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    // variables
    detailsForm;
    applicationTypes = [];
    tradingGoods = [];
    tradingGoodIsRequired = false;
    showPreviousApplicationReferenceNumberField = false;
    showReferenceNumberVerifiedLabel = false;
    showVerifyReferenceNumberButton = false;
    hideRemovalAndAddButton = false;
    showUnVerifiedReferenceNumberLabel = false;
    showTradingGoodsButtons = true;
    isReferenceNumberVerified = false;
    showVerifiedButton = false;
    lastSelectedTradingGood = null;
    selectedApplicationItamsSubscription;
    getInformalTradeApplicationObservableSubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appControllerService, informalTradeService, changeDetectorRef, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.informalTradeService = informalTradeService;
        this.changeDetectorRef = changeDetectorRef;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        const previousApplicationReferenceNumber = this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName).value;
        if (previousApplicationReferenceNumber) {
            this.showPreviousApplicationReferenceNumberField = true;
            this.showVerifyReferenceNumberButton = true;
            this.onVerifyReferenceNumber();
        }
        else {
            this.detailsForm.get(this.applicationTypeFormControlName).setValue(null);
            this.detailsForm.get(this.applicationTypeFormControlName).setValidators([Validators.required]);
            this.detailsForm.get(this.applicationTypeFormControlName).updateValueAndValidity();
        }
        if (this.detailsForm.pristine || this.isApplicationLoadedFromTheSearchPage) {
            this.getLookups();
        }
        else {
            this.loadLookups();
        }
        this.setupSubscribers();
        // Check if the previous application reference number is verified
        if (this.isReferenceNumberVerified) {
            this.getApplicationByReferenceNumber(this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName).value);
        }
    }
    loadLookups() {
        const applicationTypeLookupsLoaded = this.aflaModuleStrategyService.lookups.has(CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME);
        const tradingGoodsLookupsLoaded = this.aflaModuleStrategyService.lookups.has(CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME);
        if (applicationTypeLookupsLoaded && tradingGoodsLookupsLoaded) {
            this.applicationTypes = this.aflaModuleStrategyService.lookups.get(CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME);
            this.tradingGoods = this.aflaModuleStrategyService.lookups.get(CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME);
        }
        else {
            this.getLookups();
        }
    }
    loadMetadata() {
    }
    onTradingGoodsSelected($event, i) {
        const selectedTradingGood = $event.target?.value;
        const tradingGoods = this.getTradingGoods().controls;
        // Check if the selected item is "Other"
        if (selectedTradingGood && selectedTradingGood.trim().toLowerCase() === "other") {
            this.lastSelectedTradingGood = selectedTradingGood;
            const tradingGoodsDescriptionFormControl = tradingGoods[i].get(this.tradingGoodsDescriptionFormControlName);
            tradingGoodsDescriptionFormControl.enable();
            tradingGoodsDescriptionFormControl.reset();
            tradingGoodsDescriptionFormControl.addValidators(Validators.required);
            tradingGoodsDescriptionFormControl.updateValueAndValidity();
            this.tradingGoodIsRequired = true;
            // Check for duplicate "Other" with the same description
            tradingGoodsDescriptionFormControl.valueChanges.subscribe(description => {
                const isDuplicateDescription = tradingGoods.some((control, index) => {
                    if (index !== i) {
                        const controlDescription = control.get(this.tradingGoodsDescriptionFormControlName)?.value?.trim().toLowerCase();
                        return control.get("tradeGoods")?.value.trim().toLowerCase() === "other" && controlDescription === description?.trim().toLowerCase();
                    }
                    return false;
                });
                if (isDuplicateDescription) {
                    this.appControllerService.showMessage(CreateApplicationDetailsItamsConstants.DUPLICATE_ERROR_DESCRIPTION, AlertType.Error);
                    //tradingGoodsDescriptionFormControl.setValue(null);
                }
            });
        }
        else {
            const isDuplicate = tradingGoods.some((control, index) => {
                return index !== i && control.get("tradeGoods")?.value === selectedTradingGood;
            });
            if (isDuplicate) {
                this.appControllerService.showMessage(CreateApplicationDetailsItamsConstants.DUPLICATE_ERROR_TRADE_GOODS, AlertType.Error);
                const tradingGoodFormControl = tradingGoods[i].get("tradeGoods");
                tradingGoodFormControl.setValue(null);
                return;
            }
            this.lastSelectedTradingGood = selectedTradingGood;
            const tradingGoodsDescriptionFormControl = tradingGoods[i].get(this.tradingGoodsDescriptionFormControlName);
            tradingGoodsDescriptionFormControl.clearValidators();
            tradingGoodsDescriptionFormControl.updateValueAndValidity();
            tradingGoodsDescriptionFormControl.disable();
            this.tradingGoodIsRequired = false;
        }
        this.changeDetectorRef.detectChanges();
    }
    onApplicationTypeSelected($event) {
        const selectedApplicationType = $event.target?.value;
        const previousApplicationReferenceNumberFormControl = this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName);
        if (selectedApplicationType && selectedApplicationType.trim().toLowerCase() === "renewal") {
            previousApplicationReferenceNumberFormControl.addValidators(Validators.required);
            previousApplicationReferenceNumberFormControl.updateValueAndValidity();
            this.showPreviousApplicationReferenceNumberField = true;
            this.showVerifyReferenceNumberButton = true;
            this.hideRemovalAndAddButton = true;
        }
        else {
            previousApplicationReferenceNumberFormControl.clearValidators();
            previousApplicationReferenceNumberFormControl.updateValueAndValidity();
            this.resetTradingGoodsArray();
            this.showPreviousApplicationReferenceNumberField = false;
            this.showVerifyReferenceNumberButton = false;
            this.hideRemovalAndAddButton = false;
            this.showTradingGoodsButtons = true;
        }
        this.changeDetectorRef.detectChanges();
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(CreateApplicationDetailsItamsConstants.DETAILS_FORM_GROUP_NAME);
        if (this.detailsForm.pristine) {
            this.getTradingGoods().clear();
            this.onBtnAddTradingGoodsClicked();
        }
        this.detailsForm.enable();
        this.changeDetectorRef.detectChanges();
    }
    getLookups() {
        const params = {
            $filter: `(moduleId eq ${this.appControllerService.selectedModuleID}) and ((name eq '${CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME}' and deleted eq false) or (name eq '${CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME}' and deleted eq false))`
        };
        this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
                // this.sortDropdowns();
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsItamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const tradingGoods = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.trim().toLowerCase() === `${CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME?.trim().toLowerCase()}`) {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name?.trim().toLowerCase() === `${CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME?.trim().toLowerCase()}`) {
                    tradingGoods.push(JSON.parse(item.content));
                }
            });
            this.applicationTypes = applicationTypes;
            this.tradingGoods = tradingGoods;
            this.sortDropdowns();
            this.aflaModuleStrategyService.lookups.set(CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME, this.applicationTypes);
            this.aflaModuleStrategyService.lookups.set(CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME, this.tradingGoods);
            if (this.isApplicationLoadedFromTheSearchPage) {
                this.checkApplicationData();
            }
            this.changeDetectorRef.detectChanges();
        }
    }
    sortDropdowns() {
        if (this.applicationTypes.length > 0) {
            this.applicationTypes.sort((a, b) => (a.value.localeCompare(b.value)));
        }
        if (this.tradingGoods.length > 0) {
            this.tradingGoods.sort((a, b) => (a.value.localeCompare(b.value)));
        }
        this.changeDetectorRef.detectChanges();
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationItamsSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            this.selectedApplication = +this.jobId > 0 && application ? application : null;
            if (this.selectedApplication) {
                this.updateComponentData(this.selectedApplication);
            }
        });
    }
    setupSubscribers() {
        this.subscribeToSelectedApplication();
        this.subscribeToClearApplicationVerificationSubject();
    }
    updateComponentData(selectedApplication) {
        const selectedApplicationType = selectedApplication.type;
        if (selectedApplicationType && selectedApplicationType.trim().toLowerCase() === "renewal") {
            this.showPreviousApplicationReferenceNumberField = true;
            this.hideRemovalAndAddButton = true;
            this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName).setValue(selectedApplication.previousReferenceNumber);
            this.isReferenceNumberVerified = true;
        }
        else {
            this.showPreviousApplicationReferenceNumberField = false;
        }
        this.updateFormData();
    }
    onVerifyReferenceNumber() {
        const previousApplicationReferenceNumber = this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName).value;
        if (previousApplicationReferenceNumber) {
            this.getApplicationByReferenceNumber(previousApplicationReferenceNumber);
        }
        else {
            this.appControllerService.showMessage(CreateApplicationDetailsItamsConstants.ENTER_REFERENCE_NO, AlertType.Warning);
        }
    }
    getApplicationByReferenceNumber(previousApplicationReferenceNumber) {
        const params = {
            $filter: `referenceNumber eq '${previousApplicationReferenceNumber}' and deleted eq false`,
            $expand: "bays, traders($expand=groups), tradeGoods, status"
        };
        this.getInformalTradeApplicationObservableSubscription = this.informalTradeService.getInformalTradeApplicationObservable(params).subscribe({
            next: (response) => {
                if (response && response.length > 0) {
                    const application = response[0];
                    this.handleApplicationFound(application);
                }
                else {
                    this.handleApplicationNotVerified();
                }
                this.changeDetectorRef.detectChanges();
            },
            error: (err) => {
                this.appControllerService.handleServerErrorMessage("get applications", err, CRUDOperation.Get);
            }
        });
    }
    handleApplicationFound(application) {
        if (application.status === null) {
            this.appControllerService.showMessage(`The application with reference number ${application.referenceNumber} cannot be used as it is still active. Please try another application`, AlertType.Warning);
            return;
        }
        const applicationStatus = application.status.workflowSection;
        const applicationPercentageComplete = application.status.percentageComplete;
        const previousApplicationReferenceNumberControl = this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName);
        if (applicationStatus?.toLowerCase() === "closed" || applicationPercentageComplete === 100) {
            this.showReferenceNumberVerifiedLabel = true;
            this.showUnVerifiedReferenceNumberLabel = false;
            previousApplicationReferenceNumberControl.setValue(application.referenceNumber);
            this.showVerifiedButton = true;
            this.isReferenceNumberVerified = true; // Set this to true when the reference number is verified
            this.populateTradingGoodsFieldsFromPreviousApplication(application);
            this.populateBaysFieldsFromPreviousApplication(application);
            this.populateTradersFromPreviousApplication(application);
        }
        else {
            this.appControllerService.showMessage(`The application with reference number ${application.referenceNumber} cannot be used as it is still active. Please try another application`, AlertType.Warning);
            this.showVerifiedButton = true;
        }
    }
    populateTradingGoodsFieldsFromPreviousApplication(application) {
        const savedTradingGoods = application.tradeGoods;
        const tradingGoods = this.getTradingGoods();
        this.detailsForm.get(this.previousApplicationValidatedFormControlName).setValue(true);
        if (savedTradingGoods && savedTradingGoods.length > 0) {
            // this.showTradingGoodsButtons = false;
            tradingGoods.clear();
            savedTradingGoods.forEach((tradeGood) => {
                const tradingGoodFormGroup = new FormGroup({
                    id: new FormControl(tradeGood.id),
                    tradeGoods: new FormControl({ value: tradeGood.tradeGoods, disabled: true }, [Validators.required]),
                    tradingGoodsDescription: new FormControl({ value: tradeGood.description, disabled: true })
                });
                tradingGoods.push(tradingGoodFormGroup);
            });
        }
    }
    enableTradingGoodsFields() {
        this.getTradingGoods().enable();
    }
    resetTradingGoodsFields() {
        this.getTradingGoods().reset();
    }
    handleApplicationNotVerified() {
        this.showReferenceNumberVerifiedLabel = false;
        this.showTradingGoodsButtons = true;
        this.showUnVerifiedReferenceNumberLabel = true;
        this.hideRemovalAndAddButton = false;
        this.enableTradingGoodsFields();
        this.resetTradingGoodsFields();
        this.resetBays();
        this.resetTraders();
        this.appControllerService.showMessage("Application with matching reference number could not be found", AlertType.Warning);
    }
    populateTradersFromPreviousApplication(application) {
        const tradersFormGroup = this.aflaModuleStrategyService.form.get(this.tradersFormGroupName);
        const tradersFormControl = tradersFormGroup.get(this.tradersFormControlName);
        const traders = application.traders;
        RecipientUtils.setRecipients(traders, true, tradersFormControl);
    }
    populateBaysFieldsFromPreviousApplication(application) {
        const savedApplicationBays = application.bays;
        const applicationBaysFormGroup = this.aflaModuleStrategyService.form.get(this.baysFormGroupName);
        const savedApplicationBaysFormControl = applicationBaysFormGroup.get(this.baysFormControl);
        savedApplicationBaysFormControl.clear();
        if (savedApplicationBays && savedApplicationBays.length > 0) {
            savedApplicationBays.forEach((applicationBay) => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(applicationBay.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const formGroup = new FormGroup({
                    id: new FormControl(applicationBay.id),
                    bay: new FormControl(applicationBay),
                    address: new FormControl({ value: applicationBay.address, disabled: true }, [Validators.required]),
                    geometry: new FormControl(geom),
                    bayNumber: new FormControl({ value: applicationBay.bayNumber, disabled: true }),
                    baySize: new FormControl({ value: applicationBay.baySize, disabled: true }),
                    centroid: new FormControl(null, [Validators.required])
                });
                this.setTrueCentroid(geometryArc, formGroup, savedApplicationBaysFormControl);
            });
        }
    }
    setTrueCentroid(geometryArc, newBayFormGroup, baysFormArray) {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometryArc));
        this.getTrueCentroidSubscription = this.applicationCreateService.getTrueCentroid(url, formData).subscribe({
            next: (response) => {
                newBayFormGroup.get(this.centroidFromControlName).setValue(response.results[0].value);
                baysFormArray.push(newBayFormGroup);
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsItamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    subscribeToClearApplicationVerificationSubject() {
        this.applicationCreateService.$clearApplicationVerificationSubject.subscribe({
            next: (clearApplicationVerificationData) => {
                if (clearApplicationVerificationData) {
                    this.tradingGoodIsRequired = false;
                    this.showPreviousApplicationReferenceNumberField = false;
                    this.showReferenceNumberVerifiedLabel = false;
                    this.showVerifyReferenceNumberButton = false;
                    this.hideRemovalAndAddButton = false;
                    this.showUnVerifiedReferenceNumberLabel = false;
                    this.changeDetectorRef.detectChanges();
                }
            }
        });
    }
    getTradingGoods() {
        const tradeGoodsFormArray = this.detailsForm.get("tradeGoods");
        return tradeGoodsFormArray;
    }
    onBtnRemoveTradingGoods(i) {
        const controls = this.getTradingGoods();
        if (controls.controls.length > 1) {
            controls.removeAt(i);
        }
    }
    onBtnAddTradingGoodsClicked() {
        const tradingGoodsControl = this.getTradingGoods();
        const tradingGoodsGroup = new FormGroup({
            tradeGoods: new FormControl(null, [Validators.required]),
            tradingGoodsDescription: new FormControl({ value: null, disabled: true })
        });
        tradingGoodsControl.push(tradingGoodsGroup);
    }
    checkApplicationData() {
        const isFormPristine = this.detailsForm.pristine;
        const isFormUnTouched = this.detailsForm.untouched;
        const isFormInvalid = this.detailsForm.invalid;
        if (isFormPristine && isFormUnTouched && isFormInvalid) {
            this.updateFormData();
        }
    }
    updateFormData() {
        this.detailsForm.get(this.descriptionFormControlName).setValue(this.selectedApplication.description);
        this.detailsForm.get(this.applicationTypeFormControlName).setValue(this.selectedApplication.type);
        this.detailsForm.get(this.descriptionFormControlName).updateValueAndValidity();
        this.detailsForm.get(this.applicationTypeFormControlName).updateValueAndValidity();
        const tradingGoodsFormArray = this.getTradingGoods();
        tradingGoodsFormArray.clear();
        if (this.selectedApplication.tradeGoods) {
            this.selectedApplication.tradeGoods.forEach((savedTradeGood) => {
                this.tradingGoods.forEach(tradeGoodLookupOption => {
                    if (tradeGoodLookupOption.value === savedTradeGood.tradeGoods) {
                        const tradingGroupForm = new FormGroup({
                            id: new FormControl(savedTradeGood.id),
                            applicationId: new FormControl(savedTradeGood.applicationId, Validators.required),
                            tradeGoods: new FormControl(savedTradeGood.tradeGoods, [Validators.required]),
                            tradingGoodsDescription: new FormControl({ value: savedTradeGood.description, disabled: true })
                        });
                        if (tradingGroupForm.get(this.tradingGoodsFormControlName).value?.toLowerCase() === "other") {
                            tradingGroupForm.get(this.tradingGoodsFormControlName).disable();
                        }
                        tradingGoodsFormArray.push(tradingGroupForm);
                        tradingGroupForm.get('tradeGoods').updateValueAndValidity();
                        tradingGroupForm.get('tradingGoodsDescription').updateValueAndValidity();
                    }
                });
            });
        }
    }
    resetTradingGoodsArray() {
        this.getTradingGoods().clear();
        this.onBtnAddTradingGoodsClicked();
    }
    resetBays() {
        const applicationBaysFormGroup = this.aflaModuleStrategyService.form.get(this.baysFormGroupName);
        const savedApplicationBaysFormControl = applicationBaysFormGroup.get(this.baysFormControl);
        savedApplicationBaysFormControl.clear();
        savedApplicationBaysFormControl.reset();
    }
    resetTraders() {
        const tradersFormGroup = this.aflaModuleStrategyService.form.get(this.tradersFormGroupName);
        const tradersFormControl = tradersFormGroup.get(this.tradersFormControlName);
        tradersFormControl.reset();
        this.detailsForm.get(this.previousApplicationValidatedFormControlName).setValue(false);
    }
    subscribeToCheckFormValidity() {
        this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.detailsForm && formGroupName === this.detailsFormGroupName) {
                    this.detailsForm.markAllAsTouched();
                    this.changeDetectorRef.markForCheck();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: InformalTradeService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationDetailsItamsComponent = __decorate([
    Component({
        selector: "app-create-application-details-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsItamsComponent);
export { CreateApplicationDetailsItamsComponent };
